export default "__VITE_ASSET__acff2084__"